import { useRef, useState } from 'react';
import { NavBar, NavBarRef } from '../../components/navBar.tsx';
import { FilterableOperationTable } from '../../components/operation-table/filterableOperationTable.tsx';
import { PageTitle } from '../../components/pageTitle.tsx';
import { Batch, Operation } from '../../types/sharedTypeImpl.ts';
import { BatchesTable, BatchesTableRef } from './batchesTable.tsx';
import { MainControlBar } from './mainControlBar.tsx';
import { MaintenanceLogTable, MaintenanceLogTableRef } from './maintenanceLogTable.tsx';
import { MiscInfoBar } from './miscInfoBar.tsx';
import { EquipmentOption, SelectedPart } from './types.ts';


export function MachineLog() {

    const [selectedEquipment, setSelectedEquipment] = useState<EquipmentOption | null>(null);
    const [selectedPart, setSelectedPart] = useState<SelectedPart | null>(null);
    const [selectedBatch, setSelectedBatch] = useState<Batch | null>(null);

    const batchHistoryTableRef = useRef<BatchesTableRef>(null);
    const navBarRef = useRef<NavBarRef>(null);
    const maintenanceLogTableRef = useRef<MaintenanceLogTableRef>(null);


    function handleOperationSaved(operation: Operation, newScrapLabel: number | undefined) {
        batchHistoryTableRef.current?.refetchCurrentBatchKpis();
        navBarRef.current?.refetchPageIssues();
        if (newScrapLabel != null) {
            alert(`Obtained scrap label: ${newScrapLabel}`);
        }
    }


    const showCncViews = selectedEquipment == null || selectedEquipment.type === 'cnc';
    return (
        <>
            <PageTitle title='Machine Log' />
            <NavBar ref={navBarRef} />
            <div className='content body--tablet'>
                <MainControlBar
                    selectedEquipment={selectedEquipment}
                    setSelectedEquipment={setSelectedEquipment}
                    selectedPart={selectedPart}
                    setSelectedPart={setSelectedPart}
                />
                <MiscInfoBar
                    selectedEquipment={selectedEquipment}
                    selectedPart={selectedPart}
                />
                {showCncViews
                    ? <>
                        <BatchesTable
                            ref={batchHistoryTableRef}
                            selectedEquipment={selectedEquipment}
                            selectedPart={selectedPart}
                            selectedBatch={selectedBatch}
                            setSelectedBatch={setSelectedBatch}
                        />
                        <FilterableOperationTable
                            batch={selectedBatch}
                            onOperationSaved={handleOperationSaved}
                        />
                    </>
                    : <>
                        <button
                            className='button--large'
                            style={{ marginTop: '16px' }}
                            onClick={() => maintenanceLogTableRef.current?.onAddOperationClicked()}
                            children='Add operation'
                        />
                        <MaintenanceLogTable
                            ref={maintenanceLogTableRef}
                            style={{ marginTop: '8px' }}
                            equipment={selectedEquipment!.id}
                        />
                    </>
                }
            </div>
        </>
    )
}
